import { createReducer, on } from '@ngrx/store';

import { AppError, ErrorType } from '@core/api';

import { errorActions } from '../actions/error.actions';
import { initActions } from '../actions/init.actions';

export const featureKey = 'error';

export type ErrorState = { error: AppError; level: ErrorType } | null;

export const initialState: ErrorState = null;

export const reducer = createReducer<ErrorState>(
  initialState,
  on(initActions.appCleanup, () => initialState),

  on(errorActions.setError, (state, { error, level }) => {
    if (level === ErrorType.ACTION && (state?.level === ErrorType.ACTION || state?.level === ErrorType.PAGE)) {
      return state;
    }
    return { ...state, error, level };
  }),
  on(errorActions.clearError, () => null)
);
